import { Company } from "@/schema/console/companies/Company";
import { atom, useAtomValue, useSetAtom } from "jotai";

type DialogAtom = {
  company?: Company;
  type: "" | "update-status" | "update-assessment-date";
};

const dialogAtom = atom<DialogAtom>({
  company: undefined,
  type: "",
});
const companyAtom = atom((get) => get(dialogAtom).company);
const typeAtom = atom((get) => get(dialogAtom).type);

function useCompanyDialog() {
  const setDialog = useSetAtom(dialogAtom);
  const company = useAtomValue(companyAtom);
  const type = useAtomValue(typeAtom);
  const resetDialog = () => setDialog({ company: undefined, type: "" });

  return {
    type,
    company,
    setDialog,
    resetDialog,
  };
}

export default useCompanyDialog;
